import React from 'react';
import autobind from 'autobind-decorator';

import {BaseComponent} from "../../BaseComponent";

export class BaseTableColumn extends BaseComponent {
    constructor(props) {
        super(props);
    }

    @autobind
    _render() {
        return <span />;
    }

    render() {
        return this._render();
    }
}
